// Microsoft Sentinel datasource mappings.
//
// Scope: endpoint:wineventlog only. Every supported hunt category resolves to
// a Windows Event Log table (SecurityEvent or Event) with an EventID filter.
// Sysmon, cloud, and MDE routing are intentionally out of scope — the user's
// config should only produce queries against the standard Windows log
// connectors (AMA/MMA). Categories that have no wineventlog EventID
// (dns, network_connection, image_load, pipe_created) are not mapped and
// will render without a datasource prelude.
import type { DatasourceMap } from '../datasource.types'

export const sentinelMap: DatasourceMap = {
  'Microsoft Sentinel': {
    any: {
      process_creation: { repo: 'SecurityEvent', eventCodes: ['4688'], unsupportedFields: ['md5', 'sha256'], },
      file_event: { repo: 'SecurityEvent', eventCodes: ['4663'], unsupportedFields: ['md5', 'sha256'],   },
      registry_event: { repo: 'SecurityEvent', eventCodes: ['4657'] },
      system: { repo: 'Event', eventCodes: ['7045', '7036'] },
      security: { repo: 'SecurityEvent', eventCodes: ['4698', '4702', '4699'] },
      authentication_events: {
        repo: 'SecurityEvent',
        eventCodes: ['4624', '4625', '4648', '4672', '4776'],
      },
      Rdp_event: { repo: 'SecurityEvent', eventCodes: ['4624', '4778', '4779'] },
    },
  },
}
